/**
 * Fit a canvas with width ÷ height = `ratio` inside an available rectangle.
 * Mirrors Android `computeCanvasSizeForRatio(float ratio, Size availableSize)`.
 */

import type { ImageFrame } from './flexibleFrame';

export function computeCanvasSizeForRatio(ratio: number, available: ImageFrame): ImageFrame {
  const availableW = Number(available.width) || 0;
  const availableH = Number(available.height) || 0;
  if (availableW <= 0 || availableH <= 0 || !Number.isFinite(ratio) || ratio <= 0) {
    return { width: 0, height: 0 };
  }
  const current = availableW / availableH;
  let w: number;
  let h: number;
  if (current > ratio) {
    h = availableH;
    w = h * ratio;
  } else {
    w = availableW;
    h = w / ratio;
  }
  return { width: w, height: h };
}
